var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"richtext-form-presenter"},[_c('rich-text',_vm._g({attrs:{"id":_vm.data.name,"value":_vm.value}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }